module.exports = __webpack_public_path__ + "img/pt-31.916fc1d1.jpg";